<template>
  <div id="report_form" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Laporan Summary</h5>

          <button
            ref="dismisModal"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="row" style="margin-bottom: 20px;">
                <div class="col-md-12">
                  <div>Brand : {{ brands ? brands : "-" }}</div>
                  <div>Tanggal : {{ formData.date ? formData.date : "-" }}</div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="table-responsive table-wrapper">
                    <table class="table table-striped custom-table mb-0">
                      <thead>
                        <tr>
                          <th>Shopee</th>
                          <th>Tokopedia</th>
                          <th>Lazada</th>
                          <th>Bukalapak</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-if="loading">
                          <tr>
                            <td colspan="7">
                              <Skeleton :count="1" />
                            </td>
                          </tr>
                        </template>
                        <template v-else>
                          <tr>
                            <td class="text-wrap">
                              <div
                                v-for="(row, index) in rows.shopee"
                                :key="index"
                              >
                                <span v-if="index == 'new_link'"
                                  >New Link = {{ row }}</span
                                >
                                <span v-if="index == 'open_link'"
                                  >Open Link = {{ row }}</span
                                >
                                <span v-if="index == 'close_link'"
                                  >Close Link = {{ row }}</span
                                >
                              </div>
                            </td>
                            <td class="text-wrap">
                              <div
                                v-for="(row, index) in rows.tokopedia"
                                :key="index"
                              >
                                <span v-if="index == 'new_link'"
                                  >New Link = {{ row }}</span
                                >
                                <span v-if="index == 'open_link'"
                                  >Open Link = {{ row }}</span
                                >
                                <span v-if="index == 'close_link'"
                                  >Close Link = {{ row }}</span
                                >
                              </div>
                            </td>
                            <td class="text-wrap">
                              <div
                                v-for="(row, index) in rows.lazada"
                                :key="index"
                              >
                                <span v-if="index == 'new_link'"
                                  >New Link = {{ row }}</span
                                >
                                <span v-if="index == 'open_link'"
                                  >Open Link = {{ row }}</span
                                >
                                <span v-if="index == 'close_link'"
                                  >Close Link = {{ row }}</span
                                >
                              </div>
                            </td>
                            <td class="text-wrap">
                              <div
                                v-for="(row, index) in rows.bukalapak"
                                :key="index"
                              >
                                <span v-if="index == 'new_link'"
                                  >New Link = {{ row }}</span
                                >
                                <span v-if="index == 'open_link'"
                                  >Open Link = {{ row }}</span
                                >
                                <span v-if="index == 'close_link'"
                                  >Close Link = {{ row }}</span
                                >
                              </div>
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div
                    class="alert alert-warning"
                    style="margin-bottom: 20px; margin-top: 20px;"
                  >
                    <ul style="margin-bottom: 0;">
                      <li>
                        New Link = Status <b>process</b> sama dengan tanggal
                        yang dipilih
                      </li>

                      <li>
                        Open Link = Status <b>process</b> di bulan yang sama,
                        kecuali tanggal yang dipilih
                      </li>

                      <li>
                        Close Link = Status <b>closed</b> di bulan yang sama
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="text-center">
                <button
                  type="button"
                  class="btn btn-md btn-warning"
                  style="margin-top: 20px; color: rgb(255, 255, 255); background-color: rgb(255, 155, 68); border-color: rgb(255, 155, 68);"
                  @click.prevent="copySummary"
                >
                  <i class="la la-clipboard"></i> Copy
                </button>
                <button
                  v-if="whatsapp_number && whatsapp_number != 0"
                  type="button"
                  class="btn btn-md btn-success"
                  style="margin-top: 20px;"
                  @click.prevent="sentSummary"
                >
                  <i class="fa fa-whatsapp"></i> Sent
                </button>
                <button
                  v-if="whatsapp_group_number"
                  type="button"
                  class="btn btn-md btn-success"
                  style="margin-top: 20px;"
                  @click.prevent="sentGroupSummary"
                >
                  <i class="fa fa-whatsapp"></i> Sent Group
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import { formatDateIndo } from "@/utils/helper";

export default {
  name: "Report",
  components: {
    Skeleton
  },
  data() {
    return {
      loading: false,
      formData: {
        date: "",
        brand_id: ""
      },
      brands: "",
      whatsapp_number: "",
      whatsapp_group_number: "",
      rows: [],
      dataCopy: ""
    };
  },
  watch: {
    isShowFormReport: {
      handler: function(val, oldVal) {
        if (val == true) {
          var that = this;
          setTimeout(function() {
            that.formData = that.formParamReport;
            that.loadReportSummary();
          }, 100);
        }
      },
      deep: true
    }
  },
  computed: {
    isShowFormReport() {
      return this.$store.state.monitoring.isShowFormReport;
    },
    formParamReport() {
      return this.$store.state.monitoring.formParamReport;
    }
  },
  filters: {
    capitalising: function(data) {
      var capitalized = [];
      data.split(" ").forEach(word => {
        capitalized.push(
          word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        );
      });
      return capitalized.join(" ");
    }
  },
  methods: {
    loadReportSummary() {
      this.loading = true;

      this.$store
        .dispatch("agent/reportSummary", this.formData)
        .then(response => {
          const { data } = response;
          this.brands = data.brands;
          this.whatsapp_number = data.whatsapp_number;
          this.whatsapp_group_number = data.whatsapp_group_number;
          this.rows = data.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
          this.loading = false;
        });
    },
    formatDateIndo(date) {
      return formatDateIndo(date);
    },
    copySummary() {
      this.dataCopy = `
SUMMARY MONITORING MP ${this.brands.toUpperCase()}
${this.formatDateIndo(this.formData.date)}
--------------------
`;

      for (const platform in this.rows) {
        this.dataCopy += `
*${platform.charAt(0).toUpperCase() + platform.slice(1)}*
--------------------
New Link = ${this.rows[platform].new_link}
Open Link = ${this.rows[platform].open_link}
Close Link = ${this.rows[platform].close_link}
`;
      }

      this.copyToClipboard(this.dataCopy);
      this.$fire({
        title: "Sukses",
        text: "Laporan Summary berhasil di copy.",
        type: "success",
        timer: 1000
      });
    },
    sentSummary() {
      let dataSent = "";
      dataSent = `
SUMMARY MONITORING MP ${this.brands.toUpperCase()}
${this.formatDateIndo(this.formData.date)}
--------------------
`;

      for (const platform in this.rows) {
        dataSent += `
*${platform.charAt(0).toUpperCase() + platform.slice(1)}*
--------------------
New Link = ${this.rows[platform].new_link}
Open Link = ${this.rows[platform].open_link}
Close Link = ${this.rows[platform].close_link}
`;
      }
      window.open(
        `https://api.whatsapp.com/send?phone=${
          this.whatsapp_number
        }&text=${encodeURIComponent(dataSent)}`
      );
    },
    sentGroupSummary() {
      let dataSent = "";
      dataSent = `
SUMMARY MONITORING MP ${this.brands.toUpperCase()}
${this.formatDateIndo(this.formData.date)}
--------------------
`;

      for (const platform in this.rows) {
        dataSent += `
*${platform.charAt(0).toUpperCase() + platform.slice(1)}*
--------------------
New Link = ${this.rows[platform].new_link}
Open Link = ${this.rows[platform].open_link}
Close Link = ${this.rows[platform].close_link}
`;
      }
      window.open(
        `https://api.whatsapp.com/send?phone=${
          this.whatsapp_group_number
        }&text=${encodeURIComponent(dataSent)}`
      );
    },
    copyToClipboard(text) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.setAttribute("readonly", "");
      textarea.style.position = "absolute";
      textarea.style.left = "-9999px";
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/monitoring/summary/components/reportAgent.vue